<template>
  <div id="app">
    <transition name="fade">
      <div v-if="showBg" :style="{backgroundImage: `url(${headImg})`}" class="top-head" />
    </transition>
    <div class="top-nav">
      <img loading="lazy" src="./assets/logo.png" class="logo" />
      <div class="menu">
        <div
          v-for="item in menus"
          :key="item.name"
          :class="{'is-active': item.name === active}"
          class="menu-item"
          @click="handleClick(item.name)"
        >
          {{ item.title }}
        </div>
        <span style="color: white;font-size: 18px; font-weight: 600;margin-left: 16px;">中文</span>
        <div style="border-left: 1px solid #D3D0D2;height: 12px;margin: 0 8px;margin-top: 8px;" />
        <span style="font-size: 18px;color: #D3D0D2;cursor: pointer;" @click="changeLan">EN</span>
      </div>
    </div>
    <router-view class="content" @second-tab="handleSecondTab"/>
    <div class="bottom">
      <div class="bottom-inner">
        <div class="bottom-logo">
          <img loading="lazy" src="./assets/logo.png" alt="" width="178">
        </div>
        <div class="d-flex">
          <div class="bottom-menu">
            <div
              v-for="item in bottomList"
              :key="item.name"
              class="menu-item"
              :style="item.style || {}"
            >
              <div class="item-first" @click="go(item.name)">{{ item.title }}</div>
              <div
                v-for="child in item.children"
                :key="child.name"
                class="item-second"
                @click="go(child.path)"
              >
                {{ child.title }}
              </div>
            </div>
          </div>
          <div style="background: rgba(255,255,255,0.3); text-align: center;width: 160px;height: 188px;padding-top: 8px;">
            <img loading="lazy" src="./assets/code.png" alt="" width="140" height="140">
            <div style="line-height: 40px;color: white;">智姬公众号</div>
          </div>
        </div>
        <div class="d-flex bottom-copyright">
          <div style="margin-right: 64px;">
            备案号：
            <a
              class="icp-link"
              href="https://beian.miit.gov.cn/"
              target="_blank"
              rel="noopener noreferrer"
            >
              京ICP备2022008549号-3
            </a>
          </div>
          <div>@ Copyright - MaschineRobot. All RightReserved</div>
        </div>
      </div>
  </div>
  </div>
</template>
<script>
import dashboardHead from '@/assets/dashboard/head.png'
import contactHead from '@/assets/contact/head.png'
import xbciHead from '@/assets/x-bci/head.png'
import bcixHead from '@/assets/bci-x/head.png'
import embedHead from '@/assets/embed/head.png'
import interactHead from '@/assets/bci-interact/head.png'
import bciFrontHead from '@/assets/bci-front/head.png'
import bciWelfareHead from '@/assets/bci-welfare/head.png'
export default {
  data () {
    return {
      menus: [
        { name: 'home', title: '首页' },
        { name: 'non-invasive', title: '穿戴式BCI' },
        { name: 'invasive', title: '可植入BCI' },
        { name: 'interaction', title: 'BCI交互研究' },
        { name: 'welfare', title: 'BCI公益项目' },
        { name: 'forward-looking', title: 'BCI前瞻项目' },
        { name: 'contact', title: '联系我们' }
      ],
      bottomList: [
        {
          name: 'home',
          title: '首页'
        },
        {
          name: 'interaction',
          title: 'BCI交互研究',
          children: [
            { name: 'bci-emotion', title: 'BCI-Emotion', path: 'interaction?tab=0#content' },
            { name: 'bci-memory', title: 'BCI-Memory', path: 'interaction?tab=1#content' },
            { name: 'bci-sleep', title: 'BCI-Sleep&Dream', path: 'interaction?tab=2#content' },
            { name: 'bci-mind', title: 'BCI-Mind', path: 'interaction?tab=3#content' }
          ]
        },
        {
          name: 'welfare',
          title: 'BCI公益项目',
          children: [
            { name: 'bci-als', title: 'BCI-ALS', path: 'welfare' }
          ]
        },
        {
          name: 'contact',
          title: '联系我们',
          children: [
            { name: 'product', title: '项目参与', path: 'contact#product' },
            { name: 'support', title: '项目资助', path: 'contact#product' },
            { name: 'cooperate', title: '商业合作', path: 'contact#cooperate-join' },
            { name: 'join', title: '加入我们', path: 'contact#cooperate-join' }
          ]
        },
        {
          name: 'non-invasive',
          title: '穿戴式BCI',
          style: { marginTop: '-130px' },
          children: [
            { name: 'x-bci', title: 'X-BCI', path: 'non-invasive?tab=x-bci' },
            { name: 'bci-x', title: 'BCI-X', path: 'non-invasive?tab=bci-x' }
          ]
        },
        { name: 'gap', title: '' },
        {
          name: 'forward-looking',
          title: 'BCI前瞻项目',
          style: { marginTop: '-70px' },
          children: [
            { name: 'bci-enternal', title: 'BCI-意念永生计划', path: 'forward-looking#forever' },
            { name: 'bci-trans', title: 'BCI-记忆移植计划', path: 'forward-looking#remember' }
          ]
        },
        { name: 'gap', title: '' },
        // {
        //   name: 'gap',
        //   title: 'X-BCI社区',
        //   style: { marginTop: '-20px'},
        // },
        {
          name: 'invasive',
          title: '可植入BCI',
          style: { marginTop: '-20px' },
          children: [
            { name: 's-bci', title: 'S-BCI', path: 'invasive' }
          ]
        }
      ],
      active: 'home',
      secondActive: '',
      showBg: false
    }
  },
  computed: {
    headImg () {
      switch (this.active) {
        case 'home':
          return dashboardHead
        case 'contact':
          return contactHead
        case 'non-invasive':
          if (this.secondActive === 'x-bci') {
            return xbciHead
          } else if (this.secondActive !== '') {
            return bcixHead
          } else {
            return
          }
        case 'invasive':
          return embedHead
        case 'interaction':
          return interactHead
        case 'forward-looking':
          return bciFrontHead
        case 'welfare':
          return bciWelfareHead
        default:
          return ''
      }
    }
  },
  watch: {
    '$route': {
      handler (val) {
        this.showBg = false
        this.active = val.name
        setTimeout(() => {
          this.showBg = true
        })
      },
      immediate: true
    }
  },
  beforeCreate () {
    const toMatch = [
      /Android/i,
      /webOS/i,
      /iPhone/i,
      /iPad/i,
      /iPod/i,
      /BlackBerry/i,
      /Windows Phone/i
    ]
    this.isMobile = toMatch.some((pattern) => pattern.test(navigator.userAgent))
    this.isMac = navigator.userAgent.toLocaleLowerCase().indexOf('mac') >= 0

    if (this.isMobile) {
      document.body.style.transform = `scale(${window.innerWidth / 1250})`
      document.body.className = 'is-mobile'
    }
    if (this.isMac) {
      document.body.style.fontFamily = 'PingFang SC-Regular'
    } else {
      document.body.style.fontFamily = 'siyuan'
    }
  },
  methods: {
    handleClick (name) {
      this.active = name
      this.$router.push({
        path: `/page/${name}`
      })
    },
    handleSecondTab (val) {
      this.secondActive = val
    },
    go (path) {
      location.href = `/page/${path}`
    },
    changeLan () {
      if (location.href.indexOf('/page') >= 0) {
        location.href = location.href.replace('/page', '/en/page')
      } else {
        location.href = location.href + 'en'
      }
    }
  }
}
</script>
<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  // max-width: 1200px;
  margin: auto;
  position: relative;
}
.top-head {
  height: 900px;
  position: absolute;
  width: 100%;
  z-index: -1;
  background-image: url("~@/assets/header.png");
  background-size: cover;
  background-position: center;
  opacity: 1;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 1.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active for <2.1.8 */ {
  opacity: 0.2;
}
.top-nav {
  display: flex;
  height: 120px;
  align-items: center;
  max-width: 1200px;
  margin: auto;
  .logo {
    width: 178px;
    height: 56px;
    margin-right: 56px;
  }
  .menu {
    flex: 1;
    display: flex;
    .menu-item {
      margin: 0 14px;
      color: rgba(255,255,255,0.6);
      cursor: pointer;
      font-size: 18px;
    }
    .is-active {
      color: white;
      &::after {
        content: ' ';
        display: block;
        width: 24px;
        height: 3px;
        margin: 8px auto 0;
        background: white;
      }
    }
  }
}
.bottom {
  background-image: url("~@/assets/header.png");
  padding: 80px 0;
}
.bottom-inner {
  max-width: 1200px;
  margin: auto;
  .bottom-logo {
    margin-bottom: 64px;
  }
  .bottom-menu {
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    padding-bottom: 60px;
    .menu-item {
      width: 25%;
    }
    .item-top {
      margin-top:  -37px;
    }
    .item-first {
      font-weight: 600;
      font-size: 18px;
      color: #969DA0;
      line-height: 21px;
      margin-bottom: 32px;
      cursor: pointer;
    }
    .item-second {
      font-weight: 400;
      font-size: 18px;
      color: #808689;
      line-height: 21px;
      margin-bottom: 16px;
      cursor: pointer;
    }
  }
  .bottom-copyright {
    color: #808689;
    font-size: 18px;
    border-top: 1px solid #5A5A5A;
    padding-top: 32px;
    .icp-link {
      color: inherit;
      text-decoration: none;
      cursor: pointer;
      &:hover {
        color: #969DA0;
        text-decoration: underline;
      }
    }
  }
}

</style>
